import { __awaiter } from "tslib";
import { MedicalBenefitService } from "@/servicesTs/models/medicalAdmission/medicalBenefit";
const moduleBenefit = {
    namespaced: true,
    state: {
        loading: false,
        medicalBenefit: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        dataFilter: {
            node_id: null,
            service_node_id: null,
            state: null,
            paginate: true,
            name: null,
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getMedicalBenefit(state) {
            return state.medicalBenefit;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setMedicalBenefit(state, data) {
            state.medicalBenefit = data;
        },
        setPageMedicalBenefit(state, page) {
            state.medicalBenefit.current_page = page;
        },
        setDataFilter(state, dataFilter) {
            state.dataFilter.state = dataFilter.state;
            state.dataFilter.service_node_id = dataFilter.service_node_id;
            state.dataFilter.node_id = dataFilter.node_id;
            state.dataFilter.name = dataFilter.name;
        },
    },
    actions: {
        getMedicalBenefit({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const MEDICAL_BENEFIT = yield MedicalBenefitService.getFilter(Object.assign(Object.assign({}, state.dataFilter), { page: state.medicalBenefit.current_page }));
                commit("setMedicalBenefit", MEDICAL_BENEFIT);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleBenefit;
